<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";

export default {
  page: {
    title: "Map Accounts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Chart of Accounts",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Chart of Accounts",
          active: true,
        },
      ],
      data: {
        account: "",
        service: "",
        rev_account: "",
      },
      //accounts that have revenue mandetory
      transAccounts: [
        "TRANSPORT_FEES",
        "PREVIOUS_BALANCE",
        "FEES_ADDITIONS",
        "BURSARY",
        "FEES_EXEMPTION",
      ],
      mapingAccounts: [
        // "TRANSPORT_FEES",
        "PREVIOUS_BALANCE",
        "FEES_ADDITIONS",
        // "BURSARY",
        "FEES_EXEMPTION",
        "PETTY_CASH",
      ],
      assetError: "",
      revError: "",
      accountError: "",
    };
  },

  computed: {
    ...mapGetters("accounts", [
      "getMappedAccounts",
      "SaveStatus",
      "getAssetAccounts",
      "getRevenueAccounts",
      "getExpenseAccounts",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {
    // getSmsCalc() {
    // },
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchAssets: "accounts/fetchAssets",
      FetchMappedAccounts: "accounts/fetchMappedAccounts",
      MapAccountAction: "accounts/mapAccount",
      FetchExpenseAccounts: "accounts/fetchExpenseAccounts",
      FetchRevenue: "accounts/fetchRevenue",
    }),
    checkExistance() {
      //check if account is already mapped.
      if (
        this.getMappedAccounts.some(
          (account) => account.service == this.data.service
        )
      ) {
        this.accountError = "This Account is already mapped";
        return;
      } else {
        this.accountError = "";
      }
    },
    mapAccount() {
      if (this.data.account == "") {
        this.assetError = "Asset Account field can't be empty";
        return;
      } else {
        this.assetError = "";
      }
      if (
        this.data.rev_account == "" &&
        this.transAccounts.includes(this.data.service)
      ) {
        this.revError = "Account field can't be empty";
        return;
      } else {
        this.revError = "";
      }

      //check if account is already mapped.
      if (
        this.getMappedAccounts.some(
          (account) => account.service == this.data.service
        )
      ) {
        this.accountError = "This Account is already mapped";
        return;
      } else {
        this.accountError = "";
      }
      this.MapAccountAction(this.data);
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchMappedAccounts();
    this.FetchAssets();
    this.FetchRevenue();
    this.FetchExpenseAccounts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row d-flex"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_total_students')
        )
      "
    >
      <div class="col-md-12 mx-auto">
        <div class="card row">
          <div class="card-body col-md-12 mx-auto row">
            <div class="col-md-4">
              <form @submit.prevent="mapAccount">
                <div class="row d-flex">
                  <div class="form-group col-md-12 mb-3">
                    <label>Select Account</label>
                    <select
                      required
                      @change="checkExistance()"
                      v-model="data.service"
                      class="form-control"
                    >
                      <option selected value="" disabled>Select Item</option>
                      <option
                        :value="account"
                        v-for="(account, index) in mapingAccounts"
                        :key="index"
                        >{{ account.replace("_", " ") }}</option
                      >
                    </select>
                    <div class="text-danger" v-if="accountError">
                      <em>{{ accountError }}</em>
                    </div>
                  </div>
                  <div class="form-group mb-3 col-md-12">
                    <label>Map to Asset Account </label>
                    <model-list-select
                      required
                      :list="getAssetAccounts ? getAssetAccounts : []"
                      v-model="data.account"
                      option-value="id"
                      option-text="full_name"
                      class="mb-2"
                      placeholder="Select Asset Account"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="assetError">
                      <em>{{ assetError }}</em>
                    </div>
                  </div>
                  <div
                    class="form-group mb-3 col-md-12"
                    v-if="
                      transAccounts.includes(data.service) &&
                        data.service != 'BURSARY' &&
                        data.service != 'FEES_EXEMPTION'
                    "
                  >
                    <label>Map to Revenue Account </label>
                    <model-list-select
                      required
                      :list="getRevenueAccounts ? getRevenueAccounts : []"
                      v-model="data.rev_account"
                      option-value="id"
                      option-text="full_name"
                      class="mb-2"
                      placeholder="Select Revenue Account"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="revError">
                      <em>{{ revError }}</em>
                    </div>
                  </div>
                  <div
                    class="form-group mb-3 col-md-12"
                    v-else-if="
                      (transAccounts.includes(data.service) &&
                        data.service == 'BURSARY') ||
                        data.service == 'FEES_EXEMPTION'
                    "
                  >
                    <label>Map to Expense Account </label>
                    <model-list-select
                      required
                      :list="getExpenseAccounts ? getExpenseAccounts : []"
                      v-model="data.rev_account"
                      option-value="id"
                      option-text="full_name"
                      class="mb-2"
                      placeholder="Select Revenue Account"
                    >
                    </model-list-select>
                    <div class="text-danger" v-if="revError">
                      <em>{{ revError }}</em>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    v-if="SaveStatus"
                    disabled
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                  >
                    <b-spinner
                      variant="priamry"
                      small
                      label="Spinning"
                    ></b-spinner>
                    Mapping...
                  </button>
                  <button
                    v-else
                    type="submit"
                    class="btn btn-sm btn-outline-primary"
                  >
                    <i class="fa fa-check"></i>
                    Map Account
                  </button>
                </div>
              </form>
            </div>
            <div class="col-md-8">
              <b-card class="mb-2" no-body>
                <b-row no-gutters class="align-items-center">
                  <b-col md="12">
                    <b-card-header
                      ><h4
                        class="
                          card-title
                          mb-2
                          text-uppercase
                          font-weight-boldw
                          text-primary
                        "
                      >
                        Mapped Services
                      </h4></b-card-header
                    >
                    <b-card-body>
                      <div
                        class="row"
                        v-for="(mapped, index) in getMappedAccounts"
                        :key="index"
                      >
                        <dl>
                          <dt>
                            <span class="text-secondary m-1">{{
                              mapped.service.replace(/_/g, " ")
                            }}</span>
                            =>
                            <span class="text-secondary m-1"
                              >{{ mapped.account.acc_name }}
                            </span>

                            <span
                              class="text-secondary m-1"
                              v-if="mapped.rev_account"
                              >| {{ mapped.rev_account.acc_name }}
                            </span>
                          </dt>
                        </dl>
                      </div>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
